import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { colourOptions } from './data';
import { useTranslation } from 'react-i18next';

export default function Languages({ languageList = [], onChange, selectedOptions, error, isDisabled = false }) {
    const { t, i18n } = useTranslation();
    

    const options = languageList.map((lang) => ({
        value: lang.su_language_id,
        label: lang.su_language_name,
    }));
    return (
        <div>
            <Select

                options={options}
                onChange={onChange}
                value={selectedOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder={t('survey.select')}
                isDisabled={isDisabled}
            />
                {error && (
                <div style={{ color: 'red', marginTop: '6px', fontSize: '0.875rem' }}>
                    {error}
                </div>
            )}
                </div>
    )
}
